import { CommonModule } from '@angular/common';
import { Component, OnInit, Input, TemplateRef } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'rx-tooltip',
  templateUrl: './rx-tooltip.component.html',
  styleUrls: ['./rx-tooltip.component.scss'],
  imports: [CommonModule, FormsModule],
  standalone: true,
})
export class RxTooltipComponent implements OnInit {
  @Input() text: string;
  @Input() content: TemplateRef<any>;

  constructor() {}

  ngOnInit() {}
}
